import http from "@/settings/apiSettings"

class CrmAppointmentsDataService{
  delete(key: any): Promise<any> {
        return http.clientComercialOdata.delete(`/CRM_Appointments(${key})`);
      }
      save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_Appointments", data);
      }
  
}
export default new CrmAppointmentsDataService();